<template>
    <div class="st-card st-card--full">
        <div class="st-card-header">
            <div class="st-card-icon">
                <i class="fab fa-whatsapp"></i>
            </div>
            <div>
                <h2 class="st-card-title">{{ $t('companies.settings.whatsapp.title') }}</h2>
                <p class="st-card-desc">{{ $t('companies.settings.whatsapp.desc') }}</p>
            </div>
        </div>

        <div class="st-card-body">
            <div class="st-grid-2">
                <div class="st-field">
                    <label class="st-label" for="wa-phone-id">
                        {{ $t('companies.settings.whatsapp.phone_number_id') }}
                    </label>
                    <input
                        id="wa-phone-id"
                        v-model="phoneNumberId"
                        type="text"
                        class="st-input"
                    />
                </div>

                <div class="st-field">
                    <label class="st-label" for="wa-token">
                        {{ $t('companies.settings.whatsapp.access_token') }}
                    </label>
                    <input
                        id="wa-token"
                        v-model="token"
                        type="password"
                        class="st-input"
                        :placeholder="tokenSet ? $t('companies.settings.whatsapp.token_set_placeholder') : ''"
                    />
                </div>
            </div>

        </div>

        <div class="st-card-footer">
            <button
                class="st-btn st-btn--primary"
                :disabled="saving"
                @click.prevent="save"
            >
                <i class="fal fa-save" style="color: #fff !important;"></i>
                {{ $t('companies.settings.change_settings') }}
            </button>
            <button
                class="st-btn st-btn--ghost"
                :disabled="testing"
                @click.prevent="testConnection"
            >
                <i class="fab fa-whatsapp"></i>
                {{ $t('companies.settings.whatsapp.test_connection') }}
            </button>
        </div>
    </div>
</template>

<script>
import axios from '@/config/backend'
import { mapState } from 'vuex'

export default {
    name: 'SettingsWhatsApp',
    data() {
        return {
            phoneNumberId: '',
            token: '',
            saving: false,
            testing: false
        }
    },
    computed: {
        ...mapState('company', {
            companySettings: (state) => state.companySettings
        }),
        tokenSet() {
            return this.companySettings && this.companySettings.wa_access_token_set === true
        },
        baseURL() {
            return this.$store.state.baseURL
        }
    },
    watch: {
        companySettings: {
            immediate: true,
            handler(settings) {
                if (settings) {
                    this.phoneNumberId = settings.wa_phone_number_id || ''
                }
            }
        }
    },
    methods: {
        async save() {
            this.saving = true
            this.saved = false
            const body = { wa_phone_number_id: this.phoneNumberId }
            if (this.token) {
                body.wa_access_token = this.token
            }
            try {
                await axios.post(`${this.baseURL}/company/settings`, body)
                this.token = ''
                this.$store.dispatch('toast', {
                    type: 'success',
                    title: this.$t('companies.settings.settings_modified')
                })
            } catch (e) {
                this.$store.dispatch('dispatchError', e)
            } finally {
                this.saving = false
            }
        },
        async testConnection() {
            this.testing = true
            const body = { wa_phone_number_id: this.phoneNumberId }
            if (this.token) {
                body.wa_access_token = this.token
            }
            try {
                await axios.post(`${this.baseURL}/company/settings/whatsapp/test`, body)
                this.$store.dispatch('toast', {
                    type: 'success',
                    title: this.$t('companies.settings.whatsapp.test_success')
                })
            } catch (e) {
                const msg =
                    (e.response && e.response.data && e.response.data.message) ||
                    this.$t('companies.settings.whatsapp.test_error')
                this.$store.dispatch('toast', {
                    type: 'error',
                    title: msg
                })
            } finally {
                this.testing = false
            }
        }
    }
}
</script>

<style scoped>
.st-btn--ghost {
    background: transparent;
    border: 1.5px solid #e2e8f0;
    color: #334155;
}

.st-btn--ghost:hover:not(:disabled) {
    border-color: #0891b2;
    color: #0891b2;
}

.st-btn--ghost i {
    font-size: 0.9rem;
}

.st-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

</style>
